export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
};

// Cache to store preloaded images
const imageCache = new Map();

export const getCachedImage = (src) => {
  return imageCache.get(src);
};

export const preloadCarAssets = async (carModel, CAR_MODELS) => {
  if (!carModel || !CAR_MODELS[carModel]) return;

  const car = CAR_MODELS[carModel];
  const preloadPromises = [];

  // Preload view images
  Object.values(car.viewImages || {}).forEach(src => {
    if (src) {
      if (!imageCache.has(src)) {
        preloadPromises.push(
          preloadImage(src)
            .then(img => {
              imageCache.set(src, img);
              return { success: true, src, img };
            })
            .catch(error => {
              console.warn(`Failed to preload image: ${src}`, error);
              return { success: false, src, error };
            })
        );
      }
    }
  });

  try {
    const results = await Promise.all(preloadPromises);
    const successful = results.filter(r => r.success).length;
    const failed = results.filter(r => !r.success).length;
    
    if (failed > 0) {
      console.warn(`Car assets preloaded with ${failed} failures out of ${results.length} images`);
    } else {
      console.log('Car assets preloaded successfully');
    }
  } catch (error) {
    console.error('Error preloading car assets:', error);
  }
};

// Preload all car models and their views
export const preloadAllCarAssets = async (CAR_MODELS) => {
  const preloadPromises = [];
  
  Object.values(CAR_MODELS).forEach(car => {
    Object.values(car.viewImages || {}).forEach(src => {
      if (src && !imageCache.has(src)) {
        preloadPromises.push(
          preloadImage(src)
            .then(img => {
              imageCache.set(src, img);
              return { success: true, src, img };
            })
            .catch(error => {
              console.warn(`Failed to preload image: ${src}`, error);
              return { success: false, src, error };
            })
        );
      }
    });
  });

  try {
    const results = await Promise.all(preloadPromises);
    const successful = results.filter(r => r.success).length;
    const failed = results.filter(r => !r.success).length;
    
    if (failed > 0) {
      console.warn(`All car assets preloaded with ${failed} failures out of ${results.length} images`);
    } else {
      console.log('All car assets preloaded successfully');
    }
  } catch (error) {
    console.error('Error preloading all car assets:', error);
  }
}; 